import { useMutation } from '@tanstack/react-query';
import {
  type UpdatePermissionSet,
  gqlClient,
  graphql,
  queryClient,
} from '@tyro/api';
import { toast } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { permissionsKeys } from './keys';

const updatePermissionSets = graphql(/* GraphQL */ `
  mutation users_updatePermissionSet($input: [UpdatePermissionSet!]!) {
    users_updatePermissionSet(input: $input) {
      success
    }
  }
`);

export function useUpdatePermissionSets() {
  const { t } = useTranslation(['common']);

  return useMutation({
    mutationFn: async (input: UpdatePermissionSet[]) =>
      gqlClient.request(updatePermissionSets, { input }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: permissionsKeys.all });
      toast.success(t('common:snackbarMessages.updateSuccess'));
    },
    onError: () => {
      toast.error(t('common:snackbarMessages.errorFailed'));
    },
  });
}
